import styles from './Portfolio.module.css';

export default function PortfolioDetail({ icon, url, name, description }) {
    return (
        <article className={styles.portfolioCard}>
            <div className={styles.cardIcon}>
                <i className={icon} aria-hidden="true"></i>
            </div>
            <div className={styles.cardContent}>
                <h3>{name}</h3>
                <p>{description}</p>
            </div>
            <a href={url} target='_blank' rel="noopener noreferrer" className={styles.cardLink}>
                Visita il sito <i className='bx bx-link-external'></i>
            </a>
        </article>
    )
}
